import { useCreateDialogRequest } from 'components/create-dialog/CreateDialogContext';
import { Button } from 'components/ui/button';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { buttonStyle } from './buttonStyle';

interface Props {
    onClick: () => void;
    disabled?: boolean;
    children?: ReactNode;
}

/**
 * The look of an outlined action in the create dialog's footer, on the dialog's control border: Cancel, and any
 * action of a form that is neither Cancel nor the main one.
 */
export const CREATE_DIALOG_ACTION_CLASS = 'border-border-control px-4 font-medium shadow-none';

/**
 * A form's Cancel. In the create dialog it closes the dialog and the form's own handler does not run: that one
 * is the page's, and resets the form before it leaves, which the dialog must not do before it has closed.
 */
export default function CancelButton({ onClick, disabled, children }: Props) {
    const closeDialog = useCreateDialogRequest()?.close;

    return (
        <Button
            {...buttonStyle({ variant: 'outlined' }, closeDialog ? CREATE_DIALOG_ACTION_CLASS : undefined)}
            onClick={closeDialog ?? onClick}
            disabled={disabled}
        >
            {children ?? <FormattedMessage id="cancel" />}
        </Button>
    );
}

// The create dialog's sheet footer leaves Cancel out by this name.
CancelButton.displayName = 'CancelButton';
